import dynamic from 'next/dynamic';

import { toPXCombo } from '#app/helpers/toPX';
import useWindowSize from '#app/hooks/useWindowSize';

import { typo_32, typo_24 } from '../../atoms/typography/typography.module.scss';
import styles from './index.module.scss';

const Typography = dynamic(() => import('../../atoms/typography/typography'));
const Button = dynamic(() => import('../../molecules/button/button'));

const Advice = ({
 title, description, margin, padding 
}) => {
  const { isMobile, isDesktop } = useWindowSize();

  return (
    <section className={styles.wrapper} style={{ margin: toPXCombo(isDesktop, margin) }}>
      <div
        className={styles.container}
        style={{ padding: toPXCombo(isDesktop, padding) }}
      >
        {/* Text */}
        <div className={styles.text}>
          <Typography
            variant={typo_32}
            fontWeight={700}
            tag="h2"
            margin={{ bottom: [8, 8] }}
          >
            {title}
          </Typography>

          <Typography variant={typo_24} tag="span">
            {description}
          </Typography>
        </div>

        {/* Button */}
        <div className={styles.button}>
          <Button
            type="url"
            target="_blank"
            variant="black"
            href="https://api.whatsapp.com/send/?phone=17867892469&text=Hola!%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20las%20clases"
            width={isMobile ? '100%' : '276px'}
            height="48px"
            textOptions={{
              fontSize: [20, 20],
              fontWeight: 700,
              lineHeight: [21, 21]
            }}
          >
            Contacta un asesor
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Advice;
